export enum DiscountProductLimitType {
  OneProductNoLimit = 0,
  AllApplicableProducts = 1,
  WithQuantityLimits = 2,
}
